module.exports = __webpack_public_path__ + "img/moodwave-logo.65ccaa36.png";